import ReviewStars from '../reviewStars/ReviewStars';
import image1 from '../../assets/images/trvto_tripDetails.jpg';
import { toPascalCase } from '../../utils/pascalCase';
import Tooltip from '../tooltip/Tooltip';
import EditIcon from '../../assets/icons/trvto_edit_icon.svg';
import DuplicateIcon from '../../assets/icons/trvto_duplicate.png';
import '../orgTripStrap/orgTripStrap.css';

/*
 * Card for an accommodation listing inside the org's "My Packages"
 * list (OrgCampPackList, under OrgCampLayout).
 *
 * This used to be a near-verbatim copy of OrgTripStrap, reading
 * trip-only fields (data.quickView, data.price[0].price.total,
 * data.cardImages[0], data.datesType) that don't exist on a real
 * Accommodation document - every card would have thrown trying to
 * read those, or silently shown blank/undefined everywhere. It now
 * reads the actual Accommodation schema: media[], propertyType,
 * address, units[0].pricing[0], rating.average/rating.count.
 *
 * Duplicate / Edit (right side of the card) open the stay in the
 * AccommodationForm via /org/c/create/camp (OrgAccommodationUpload):
 * edit updates this stay, duplicate starts a new one pre-filled from it.
 */

const CURRENCY_SYMBOLS = {
    INR: '₹',
    USD: '$',
    AED: 'د.إ',
    EUR: '€',
    GBP: '£'
};

const PRICE_UNIT_LABELS = {
    per_night: '/night',
    per_person: '/person',
    per_unit: '/unit',
    per_bed: '/bed',
    per_package: '/package'
};

export default function OrgCampStrap({ setNav, data, setSelectedPack, selectedStatus, onEdit, onDuplicate }) {
    return (
        <div>
            {selectedStatus === 'rejected' && (
                <div className='note-section'>
                    <p>
                        Note:{' '}
                        <span>
                            Click on the package to view the rejection comment. You can edit and resubmit the package.
                        </span>
                    </p>
                </div>
            )}
            {data?.map((item) => {
                const coverImage =
                    item?.media?.find((m) => m?.isCover)?.url ??
                    item?.media?.[0]?.url ??
                    item?.cardImages?.[0] ??
                    image1;
                const firstPricing = item?.units?.[0]?.pricing?.[0];
                const currencySymbol = CURRENCY_SYMBOLS[firstPricing?.currency] || '';
                const priceUnitLabel = PRICE_UNIT_LABELS[firstPricing?.priceUnit] || '';
                const displayPrice = firstPricing?.actualPrice ?? firstPricing?.basePrice;
                const location = [item?.address?.city, item?.address?.state].filter(Boolean).join(', ');

                return (
                    <div
                        key={item._id}
                        className='org_tripStrap'
                        onClick={() => {
                            setNav(true);
                            setSelectedPack(item._id);
                        }}
                    >
                        <div className='org_tripStrapContent'>
                            <div className='org_thumbImageContainer'>
                                <img
                                    src={coverImage}
                                    alt='trvto_accommodation'
                                    className='org_tripStrapImage'
                                    loading='lazy'
                                    decoding='async'
                                />
                            </div>
                            <div className='org_tripStrapInfoDiv'>
                                <div className='org_tripStrapNameDiv alignCenter'>
                                    <div className='org_tripStrapInfo'>
                                        <div className='org_tripStrapName'>
                                            <div className='alignCenter'>
                                                <p>{item?.title}</p>
                                            </div>
                                            <div className='org_tripInfo'>
                                                {item?.propertyType && (
                                                    <div className='org_typeInfo'>{toPascalCase(item.propertyType)}</div>
                                                )}
                                                <div
                                                    className={`org_typeInfo ${item?.status === 'active' ? 'active' : ''}`}
                                                >
                                                    {toPascalCase(item?.status || ' ')}
                                                </div>
                                            </div>
                                        </div>
                                        <div className='org_tripCardNumInfo'>
                                            <ReviewStars rating={item?.rating?.average || 0} />
                                            <span>{item?.rating?.average || 0}</span>
                                            <p style={{ margin: 0 }}>({item?.rating?.count || 0} Reviews)</p>
                                        </div>
                                        {location && <p className='org_locationInfo'>{location}</p>}
                                    </div>
                                    {displayPrice != null && (
                                        <div className='org_tripStrapPriceDiv'>
                                            <div className='org_tripStrapPrDiv'>
                                                <p className='org_tripStrapPrice'>
                                                    {currencySymbol} {displayPrice}
                                                    <span>{priceUnitLabel}</span>
                                                </p>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className='editDeleteBtn'>
                                <button
                                    type='button'
                                    className='org_tripEdit'
                                    aria-label='Duplicate'
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        onDuplicate?.(item._id);
                                    }}
                                >
                                    <Tooltip content={'Duplicate'} position='bottom' className='tooltip-large'>
                                        <img src={DuplicateIcon} alt='duplicate' width={36} height={36} />
                                    </Tooltip>
                                </button>
                                <button
                                    type='button'
                                    className='org_tripEdit'
                                    aria-label='Edit'
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        onEdit?.(item._id);
                                    }}
                                >
                                    <Tooltip content={'Edit'} position='bottom' className='tooltip-large'>
                                        <img src={EditIcon} alt='edit' width={36} height={36} />
                                    </Tooltip>
                                </button>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
